import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import salesgrotopbar3 from '../../assets/images/salesgrotopbar3.png';

const AuthLayout = () => {
  return (
    <Grid container sx={{ minHeight: '100vh', justifyContent: 'center', alignItems: 'center' }}>
      {/* Left side - Logo and form (100%) */}
      <Grid 
        item 
        xs={12} 
        md={5}
        sx={{ 
          bgcolor: '#f5f5f5',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          p: { xs: 2, sm: 3 },
          position: 'relative',
          minHeight: { xs: 'auto', md: 'auto' }
        }}
      >
        {/* Logo Image */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: { xs: 0, sm: 2 },
            width: '100%',
          }}
        >
          <img src={salesgrotopbar3} alt="SalesGro Logo" style={{ maxWidth: '220px', width: '100%', height: 'auto', objectFit: 'contain' }} />
        </Box>

        {/* Form Container */}
        <Container 
          maxWidth="xs" 
          sx={{ 
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            p: 0,
            maxHeight: { xs: 'calc(100vh - 150px)', md: 'none' },
            overflow: { xs: 'auto', md: 'visible' }
          }}
        >
          <Outlet />
        </Container>
      </Grid>
      
      {/* Right side - AI features */}
      {/* Removed right half */}
    </Grid>
  );
};

export default AuthLayout;